export default __webpack_public_path__ + "static/banniere-logiciel-4555b13afa55682add24561d7777b641.png";